// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Jj-z","trustedRetailerTooltipWrapper":"Kj-z"};